import { Observable } from 'rxjs';
import { ErrorSpecification } from './error-specification';

export interface StaticErrorSpecification extends ErrorSpecification {
  type: 'static';
  description: string;
  title: Observable<string>;
  buttonName: Observable<string> | null;
}
